module.exports = __webpack_public_path__ + "static/media/progress.9e09112a.gif";